import moment from 'moment-timezone';

import { MS_PER_HOUR, MS_PER_MIN } from '../../core/constants';

export interface TimeOfDay {
  hours: number;
  minutes: number;
}

export function msFromMidnightToTimeOfDay(msFromMidnight: number): TimeOfDay {
  return {
    hours: Math.floor(msFromMidnight / MS_PER_HOUR),
    minutes: Math.floor((msFromMidnight % MS_PER_HOUR) / MS_PER_MIN),
  };
}

export function timeOfDayToMsFromMidnight(time: TimeOfDay): number {
  return (time.hours * MS_PER_HOUR) + (time.minutes * MS_PER_MIN);
}

export function msFromMidnightToTimestamp(dayTimestamp: number, timezone: string, msFromMidnight: number): number {
  const { hours, minutes } = msFromMidnightToTimeOfDay(msFromMidnight);

  return moment.tz(dayTimestamp, timezone).startOf('day')
    .hour(hours)
    .minute(minutes)
    .valueOf();
}
